/* eslint-disable sonarjs/no-duplicate-string */
import { Config } from '@cigna/cigna-for-brokers/shared/util';
import uuid from 'uuid';
export const environment: Config = {
  production: true,
  api: {
    sharedGateways: {
      cdn: 'https://a.static.cigna.com/',
      resourceContent: 'https://a.static.cigna.com/',
      directory: '',
      directoryTypeahead: '',
      directoryGeolocation: '',
      gsg: 'https://a-gsg.test.digitaledge.cigna.com',
      launchDarkly: '',

      eirAnalytics: '',
      elevateSurvey: '',
      communicationPreferencesUrl: '',
      privateLinkRouter: '',
      publicLinkRouter: '',
    },
    identity: {
      environmentName: 'rlse',
      defaultPath: '/secure/home',
      getNavigations:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/navigation/entitlements',
      searchClient:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/client/clients/search',
      getAlert:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/contenthub/content/alert',
      dismissAlert:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/contenthub/content/alert/update',
      checkIpValid:
        'https://a-cfb.test.digitaledge.cigna.com/secure/v1/ca/identity/utility/isIpValid',
      getProfileUserMatch:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfe/identity/profile/user/match',
      getContentHub:
        'https://a-cfb.test.digitaledge.cigna.com/reg/secure/v1/ca/contenthub/content/',
      userAgreementUpdate:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/preferences/user/agreementstatus',
      getCompensationStatements:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation',
      getCompensationStatementsTest:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation',
      getFirmsList:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation/access/get_firms',
      getStatementsList:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation/search/compensation-tile',
      getRFPData:
        'https://a-cfb.test.digitaledge.cigna.com/service/RequestsForProposals?peid={peid}&index={index}&sort_order={sort_order}&sort_key={sort_key}',
      getClientManagerList:
        'https://a-cfb.test.digitaledge.cigna.com/service/ContactCard?oppor_key={oppor_key}&function={function}',
      getMessagesList:
        'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athno/contents/message?metadata=lob&metadata=published_date',
      addAgency: `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation/access/add_firm`,
      getIfpCompInt: '/web/commissions-overview',
      getPartnerId:
        'https://int-cignaforemployers-03.cigna.com/isam/sps/employer-int-03-sp-broker-int2/saml20',
      getBRProfile:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/profile/navigation?service_reference_id={reqID}',
      removeAgency: `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation/access/remove_firm`,
      getAgencyList: `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation/affirmations/agencies`,
      postAffirm: `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation/affirmations/affirm`,
      getSepWorkQExtUrl: '/usr-desktop-v2/#/sep-applications/search',
      getSepWorkQIntAdmin:
        '/usr-desktop-v2/#/sep-applications/search?roleId={roleId}&brokerId={brokerId}',
      getComComp:
        'https://int-cignaproducer.cs22.force.com/s/compensation-page',
      getBrokerSecurityProfileUrl:
        'https://rlse.cignaforbrokers.com/web/broker-security-profile',
      getSpotlight:
        'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athlv/contents',
      getTools:
        'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athno/contents/tool/',
      getBrokerWelcome:
        'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athno/contents/spotlight/',
      getBusinessAlert:
        'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athno/contents/business-instant-alert/',
      getRequestForInfo: `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/rfi?service_reference_id={service_reference_id}`,
      getApplicantRfiInternal: `https://cignagbs--uat.my.salesforce.com/lightning/r/vlocity_ins__Application__c/{salesForceId}/view`,
      getApplicantRfiExternal: `https://cignagbs--uat.my.salesforce.com/s/application/{salesForceId}/`,
      getViewAllRfiInternal: `https://cignagbs--uat.my.salesforce.com/lightning/r/sObject/{objectId}/view?queryScope=userFolders`,
      getViewAllRfiExternal: `https://cignagbs--uat.my.salesforce.com/lightning/r/sObject/{objectId}/view?queryScope=userFolders`,
      clientId: 'brokers_spa_rlse_client',
      metadataUri: '/mga/sps/oauth/oauth20/metadata/brokers_spa_rlse_def',
      authorizeUri: '/mga/sps/oauth/oauth20/authorize',
      redirectUri: '/secure/auth_callback.html',
      homeSecureUri: 'secure/home/',
      cfbApiUrl: 'https://a-cfb.test.digitaledge.cigna.com/v1/cfb',
      gsgApiUrl: 'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athno',
      getMAQE:
        'https://rlse.cignaforbrokers.com/isam/sps/broker-p-idp-connecture-cigna/saml20/logininitial?PartnerId=DRX2022Agent',
      getCsbBob:
        'https://rlse.cignaforbrokers.com/gasbAgent/AgencyManagement/MyClients.aspx',
      getCsbCompensation:
        'https://rlse.cignaforbrokers.com/gasbAgent/AgencyManagement/CommissionsandDebitBalance.aspx',
      getCsbCompensation_v1:
        'https://rlse.cignaforbrokers.com/web/csb-commissions',
      addAdminRelationship: `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation/access/add-admin-relationship?service_reference_id={service_reference_id}`,
      getNotifications:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/notification',
      getComProDir:
        'https://hcpdirectory.cigna.com/web/public/consumer/directory',
      getComPreDrugList:
        'https://www.cigna.com/individuals-families/member-resources/prescription/',
      getComCigna: 'https://www.cigna.com/',
      getComCfe: 'https://cignaforemployers.cigna.com/public/app/signin',
      getTimeoutDuration: '900',
      getLogoutDuration: '300',
      getImpersonatorSwitchUserTimeoutDuration: '600',
      getImpersonatorSwitchUserLogoutDuration: '300',
      getSolutionsInsights:
        'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athno/contents/content-block?metadata=tagtype&metadata=published_date',
      getCurrentBusinessData:
        'https://a-cfb.test.digitaledge.cigna.com/service/CurrentBusiness',
      getClientSummaryData:
        'https://a-cfb.test.digitaledge.cigna.com/service/ClientProductsSummary',
      getClientManagerData:
        'https://a-cfb.test.digitaledge.cigna.com/service/ContactCard?peid={peid}&oppor_key={opportunity_key}&client_account_key={client_account_key}&function={function}',
      getMaCompensationStatements: `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/ma/compensation?service_reference_id={service_reference_id}`,
      downloadMaCompXls:
        'https://a-cfb.test.digitaledge.cigna.com/v2/contents?contentID={contentID}&contentType={contentType}&controlKey={controlKey}&expirationTimeStamp={expirationTimeStamp}',
      getMedicareEligibilityLookup:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/wipro?action=eligibility-query',
      getMedicaidEligibilityLookup:
        'https://a-cfb.test.digitaledge.cigna.com/v1/medicaidEligLookup',
      getTokenRequest:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/util/token?service_reference_id={request_ref_id}',
      getMaCompPaymentScheduleUrl:
        'https://a.static.cigna.com/secure/cfb/pdf/2023-cigna-medicare-commission-payment-schedule.pdf',
      getCompReportsList:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/ma/compensation/report',
      sendPostLoginContactUsEmailNotification:
        'https://a-cfb.test.digitaledge.cigna.com/v1/secure/cfb/email/notification',
      sendPreLoginContactUsEmailNotification:
        'https://a-cfb.test.digitaledge.cigna.com/v1/public/cfb/email/notification',
      customer: 'string',
      publicCpi: 'string',
      privateCpi: 'string',
      jwtFrontend: 'string',
      getRequestNewAccessCodeUrl:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/broker/request/access',
      getAccessCodeValidation:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/registration/accesscode/validation',
      lastLoginDateUpdate:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/profile/user/logindate',
      verifySecurity:
        'https://a-cfb.test.digitaledge.cigna.com/public/recovery/v1/mfa/factor/sq/verify',
      resetPasswordUrl:
        'https://a-cfb.test.digitaledge.cigna.com/public/recovery/v1/password/reset',
      stateTokenUrl:
        'https://a.login.cignaforbrokers.com/api/v1/authn/recovery/token',
      saveSecurityQuestion:
        'https://a-cfb.test.digitaledge.cigna.com/cfb/profile-settings/v1/recovery-question',
      changePassword:
        'https://a-cfb.test.digitaledge.cigna.com/cfb/profile-settings/v1/change-password',
      verifyFactorUrl:
        'https://a.login.cignaforbrokers.com/api/v1/authn/recovery/password',
      verifyUserData:
        'https://a-cfb.test.digitaledge.cigna.com/public/recovery/v1/password/search',
      getRegistrationSubmit:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/registration/user',
      verifyPasscode:
        'https://a.login.cignaforbrokers.com/api/v1/authn/recovery/factors/sms/verify',
      getForgotUsernameFindUserData:
        'https://a-cfb.test.digitaledge.cigna.com/public/recovery/v1/user/search',
      getForgotUsernameVerifyUserData:
        'https://a-cfb.test.digitaledge.cigna.com/public/recovery/v1/mfa/factor/verify',
      validateEmail:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/registration/email/validation',
      getUsernameValidation:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/registration/username/validation',
      getForgotUsernameRequestUserData:
        'https://a-cfb.test.digitaledge.cigna.com/public/recovery/v1/mfa/factor/send',
      getSecurityProfileUserData:
        'https://a-cfb.test.digitaledge.cigna.com/cfb/profile-settings/v1/user',
      getSecurityProfileFactorsData:
        'https://a-cfb.test.digitaledge.cigna.com/cfb/profile-settings/v1/factors',
      addSecurityProfileEmailFactor:
        'https://a-cfb.test.digitaledge.cigna.com/cfb/profile-settings/v1/factors/email',
      addSecurityProfileMobileFactor:
        'https://a-cfb.test.digitaledge.cigna.com/cfb/profile-settings/v1/factors/sms',
      activateSecurityProfileMobileFactor:
        'https://a-cfb.test.digitaledge.cigna.com/cfb/profile-settings/v1/factors/sms/lifecycle/activate',
      activateSecurityProfileEmailFactor:
        'https://a-cfb.test.digitaledge.cigna.com/cfb/profile-settings/v1/factors/email/lifecycle/activate',
      resendSecurityProfileMobileFactor:
        'https://a-cfb.test.digitaledge.cigna.com/cfb/profile-settings/v1/factors/sms/resend',
      resendecurityProfileEmailFactor:
        'https://a-cfb.test.digitaledge.cigna.com/cfb/profile-settings/v1/factors/email/resend',
      accessCdValidateEmail:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/registration/access/email/validation',
      profilePreLoad:
        'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/profile/login',
      profilePreLoadKey:
        'FEF02D321607467B0141782D2D3605378CE2F501A5A9B121FE5F3B6B0B4A8FF2',
      getOktaExtRedirect:
        'https://rlse.cignaforbrokers.com/isam/sps/oidc/rp/brokers-rlse-okta/kickoff/okta-rlse-brokers?Target=',
      getKeepAlive: 'https://rlse.cignaforbrokers.com/keepalive.gif',
      getAgentViewOktaExtRedirect:
        'https://i2-agentview.healthcare.cigna.com/isam/sps/oidc/rp/agentview-i2-okta/kickoff/okta-i2-agentview?Target=',
      kaplanEmail: 'Akashkumar.Panda@Cigna.com',
      getSnowUrl:
        'https://cigna.service-now.com/esp?id=sc_cat_item&sys_id=f04a8394db55c850abcafb5aaf961903&referrer=popular_items',
      getSgRenewals: `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/client/renewals?service_reference_id={service_reference_id}`,
      getSgRenewalDownload: `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/client/renewals`,
      downloadBobCsv:
        'https://d-cfb.dev.digitaledge.cigna.com/v1/cfb/ma/compensation/report/current-business-csv',
      downloadRfpCsv:
        'https://d-cfb.dev.digitaledge.cigna.com/v1/cfb/ma/compensation/report/rfp-data-csv',
    },
    extUrls: {
      getCFELoginLink:
        'https://sit.test-cignaforemployers.cigna.com/public/app/signin',
      getCFEFederationUrl:
        'https://int2.cignaforbrokers.com/isam/sps/broker-int2-idp-employer-int-03/saml20/logininitial?PartnerId={partnerId}&clientId={clientId}&clientSourceCd={clientSourceCd}&clientPortalUserId={clientPortalUserId}',
      getUserSession:
        'https://rlse.cignaforbrokers.com/service/v1/retail/broker/roles/default',
      getIfpCompExt:
        '/web/commissions-overview?roleId={roleId}&brokerId={brokerId}',
      getIfpResourceCenterExt:
        '/web/resource-center?roleId={roleId}&brokerId={brokerId}',
      getIfpMedicalExtAgent:
        'https://staging.healthsherpa.com/dashboard?user_type=agent',
      getBrokerQuoteMedical:
        'https://staging.healthsherpa.com/dashboard?user_type=agent',
      getBrokerQuoteDental: '/equotes',
      getBrokerQuoteDentalAdmin: '/equotes?roleId={roleId}&brokerId={brokerId}',
      getBrokerQuoteDentalNew: 'https://reldental.cigna.com/cfbdentalpro',
      getIfpMedicalAgency: 'https://staging.healthsherpa.com/?_agent_id=cigna',
      getIfpMedicalAdmin:
        'https://staging.healthsherpa.com/?_agent_id=cigna?roleId={roleId}&brokerId={brokerId}',
      getBrokerQuoteAdvantage2022:
        'https://int2.cignaforbrokers.com/isam/sps/broker-int2-idp-connecture-cigna/saml20/logininitial?PartnerId=DRX2022AgentStage',
      getBrokerQuoteAdvantage2025:
        'https://int2.cignaforbrokers.com/isam/sps/broker-int2-idp-connecture-cigna/saml20/logininitial?PartnerId=DRX2025StageAgent',
      getBrokerQuoteAdvantage:
        'https://rlse.cignaforbrokers.com/isam/sps/broker-p-idp-connecture-cigna/saml20/logininitial?PartnerId=DRX2022Agent',
      getBrokerBobCommercial:
        'https://int-cignaproducer.cs22.force.com/s/current-business',
      getBrokerBobPlans:
        '/web/book-of-business?roleId={roleId}&brokerId={brokerId}',
      getBrokerBobAdvantage:
        'https://cignagbs--uat.lightning.force.com/lightning/r/sObject/00O1U0000081BZ6UAM/view?queryScope=userFolders',
      getBrokerBobBenefits: 'https://rlse.cignaforbrokers.com/web/gov-bob',
      getBrokerQuoteBenefits:
        'https://rlse.cignaforbrokers.com/equotes/?AuthUserToken=e5lXDx060ROv4rF2pBEfpJlRUYqpTI2435cuSfhKyRIRTa0bpQht6cw3JznJsShtOCxY%2bN1XU0%2fH5zxQT8vHQ7iEONXKf%2bxFrwRzySSKfoshI8xlhun4xlv%2f%2brb4Uh%2fct3pWO57bn34TIdWAYahpgiQbn627J42PCZG%2b%2fynW9aY%3d',
      getBrokerBobMaApplication:
        'https://cignagbs--uat.lightning.force.com/lightning/r/sObject/00O1U000004czkMUAQ/view?queryScope=userFolders',
      getMABOBInt:
        'https://cignagbs--uat.lightning.force.com/lightning/r/sObject/00O1U0000081IhrUAE/view?queryScope=userFolders',
      getMABOBExt:
        'https://cignagbs--uat.lightning.force.com/lightning/r/sObject/00O1U0000081BZ6UAM/view?queryScope=userFolders',
      getMAAppStatusInt:
        'https://cignagbs--uat.lightning.force.com/lightning/r/sObject/00O1U000004czkNUAQ/view?queryScope=userFolders',
      getMAAppStatusExt:
        'https://cignagbs--uat.lightning.force.com/lightning/r/sObject/00O1U000004czkMUAQ/view?queryScope=userFolders',
      getIfpAdminUrl: '/web/admin?roleId={roleId}&brokerId={brokerId}',
      getSepWorkQIntUrl: '/usr-desktop-v2/#/sep-applications/search',
      getComReqProposal:
        'https://int-cignaproducer.cs22.force.com/s/request-for-proposals',
      getComTraining:
        'https://int-cignaproducer.cs22.force.com/s/on-demand-training',
      getComContinueEdu:
        'https://int-cignaproducer.cs22.force.com/s/continuing-education',
      getComSolutionInsight:
        'https://int-cignaproducer.cs22.force.com/s/solutions-and-insights',
      getCsbQuoteEnroll: 'https://rlse.cignaforbrokers.com/equotes/',
      getCsbSalesMarketingMtrl:
        'https://rlse.cignaforbrokers.com/gasbAgent/FormsAndMaterials/FormsAndMaterials_POD.aspx',
      getCsbSalesMarketingMtrl_v1:
        'https://rlse.cignaforbrokers.com/isam/sps/broker-int2-idp-rrDonnelly/saml20/logininitial?PartnerId=rrd.saml2.sp.test&Target=http%3A%2F%2Ftestcustompoint.rrd.com%2Fcsb',
      getCsbIncentives: 'https://rlse.cignaforbrokers.com/web/incentives',
      getCsbPolicyReporting_v1:
        'https://rlse.cignaforbrokers.com/web/csb-policy-reporting',
      getCsbPolicyReporting:
        'https://rlse.cignaforbrokers.com/gasbagent/agencymanagement/productionreports/reportselection.aspx',
      getCsbAgentInquiry_v1:
        'https://rlse.cignaforbrokers.com/web/csb-agent-inquiry',
      getCsbAgentInquiry:
        'https://rlse.cignaforbrokers.com/gasbagent/AgencyManagement/activeagentssearch.aspx',
      getCsbRecruiting: 'https://rlse.cignaforbrokers.com/expressway/',
      getCsbTraining: 'https://cigna.uat4.pinpointglobal.com/Portal/Login',
      getCsbTraining_v1:
        'https://rlse.cignaforbrokers.com/isam/sps/broker-int2-idp-pinPoint/saml20/logininitial?PartnerId=https://cigna.uat4.pinpointglobal.com/Portal/SAML2',
      getCsbMyCustomers:
        'https://rlse.cignaforbrokers.com/gasbAgent/AgencyManagement/MyClients.aspx',
      getNewCsbBob: 'https://rlse.cignaforbrokers.com/web/gov-bob',
      getCsbProductInfo:
        'https://rlse.cignaforbrokers.com/web/gov-resource-center/product-info',
      getCsbBusinessBuilding:
        'https://rlse.cignaforbrokers.com/web/gov-resource-center/business-building',
      getCsbBenefits:
        'https://rlse.cignaforbrokers.com/web/gov-resource-center/benefits',
      getCsbServicingForms:
        'https://rlse.cignaforbrokers.com/web/gov-resource-center/servicing-forms',
      getCsbToolsExpressApp: 'https://rlse.cignaforbrokers.com/equotes/',
      getCsbToolsExpressWay:
        'https://rlse.cignaforbrokers.com/gasbAgent/ExpressWay.aspx',
      getOnDemandExploreContent:
        'https://int2.cignaforbrokers.com/isam/sps/broker-int2-idp-bigtincan/saml20/logininitial?PartnerId=https://cignaforbrokerssandbox.push.bigtincan.com/saml/metadata',
      getContinuingEdExploreCatalog:
        'https://int2.cignaforbrokers.com/isam/sps/broker-int2-idp-kaplan/saml20/logininitial?PartnerId=https://portal.kaplanfinancial.com/partner/cignaiceuat/saml2/metadata',
      getContinuingEdExploreCatalogNew:
        'https://iam.kaplanlearn.com/api/initSso/7006797-1755201675387?portal=CignaICEUAT&clientId=18o4edr70d0gg9u44odft5m2lb',
      getFindPharmacy2023:
        'https://cigna.destinationrx.com/compare/MDC/2023/Home/Home',
      getFindPharmacy2026:
        'https://Healthspring.destinationrx.com/Compare/MDC/2026',
      getMaPdpPlans:
        'https://int2.cignaforbrokers.com/isam/sps/broker-int2-idp-connecture-cigna/saml20/logininitial?PartnerId=DRX2025StageAgent',
      getIfpHPS:
        'https://fsso.cigna.com/fsso/sps/fsso-prd-idp-healthplan/saml20/logininitial?RequestBinding=HTTPPost&NameIdFormat=email&PartnerId=https://ssoprod.healthplan.com&Target=https%3A%2F%2Fservice.healthplan.com%2FJ1SLP%2Fsso',
      getCSBAdam: '/web/broker-maintenance',
      getCSBAdamLeadsDashboard: '/web/leads-dashboard',
      getCSBAdamNewInsuranceUpdate: '/web/new-insurance-update',
      getFindPharmacy2025:
        'https://cigna.staging.destinationrx.com/Compare/MDC/2025',
      getQuoteEnrollOtherStates: 'https://rlse.cignaforbrokers.com/expressapp',
      redirectToNewPortalUrl:
        'https://d1pl4xsksyewvn.cloudfront.net/public/login',
      upcomingEvents:
        'https://portal.kaplanfinancial.com/partner/cignaice/portal',
    },
  },
  contentBundle: {
    manifestFilename: `content/cfb/manifest.json?v=${uuid.v4()}`,
  },
  features: {
    isDashboardChartsEnabled: false,
    isOnDemandTrainingEducationEnabled: true,
    isBookOfbusinessEnabled: true,
    isVisitOnCurrentBusinessEnabled: true,
    isMaCompensationEnabled: true,
    isImpersonatorEnabled: true,
    isCompensationEnabled: true,
    isMedicareMedicaidLookupEnabled: true,
    isMedicaIdMockDataEnabled: true,
    isInstantAlertEnabled: true,
    isIfpAdminEnabled: true,
    isPostLoginContactUsIntuitiveEnabled: true,
    isSecurityProfileEnabled: true,
    isForgotPasswordEnabled: true,
    isAuthGuardEnabled: true,
    isOktaLoginEnabled: true,
    isOnDemandUpdateEnabled: true,
    isCSBIncentivesEnabled: true,
    isOKTASecureUriEnabled: false,
    isOldImpersonationEnabled: true,
    did0621ChangesEnabled: true,
    did0228ChangesEnabled: true,
    didTraining0214ChangesEnabled: true,
    did0706ChangesEnabled: true,
    did0720ChangesEnabled: true,
    did0803ChangesEnabled: true,
    did0830ChangesEnabled: true,
    isCfeMultiUsernameEnabled: true,
    isPreloginNewUiEnabled: true,
    isKaplanLegalSectionEnabled: true,
    isOnboardingEnabled: false,
    isIfpHPSEnabled: true,
    isNewRegistrationFlowEnabled: true,
    isOpenEnrollmentEnabled: true,
    isIFPMphasisEnabled: true,
    isDivestEnabled: false,
    isNewMarketingMaterialsEnabled: false,
  },
  sessionTimeoutPopup: {
    timeoutDuration: 15,
    logoutDuration: 5,
    keepAliveUrl: '/app/assets/images/isam-keepalive.gif',
    keepAliveInterval: 5,
  },
  okta: {
    clientId: 'nfbfkdpL16rFMOmHwiUC',
    issuer: 'https://a.login.cignaforbrokers.com/oauth2/default',
    redirectUri: '/public/login/callback',
    postLogoutRedirectUri: '/public/login',
    tokenExpirationInMin: 5,
    cookieStorage: true,
  },
  oidc: {
    clientId: 'nfbfkdpL16rFMOmHwiUC',
    redirectUri: '/public/login/callback',
    metadataUri:
      'https://a.login.cignaforbrokers.com/oauth2/default/.well-known/oauth-authorization-server',
    authorizeUri: '/web/secure/consumer/authorize',
    nonsecureUris: [
      'secure/home/',
      'https://a-cfb.test.digitaledge.cigna.com/cfb/profile-settings/v1',
      'https://a-cfb.test.digitaledge.cigna.com/cfb/profile-settings/v1/recovery-question',
      'https://a-cfb.test.digitaledge.cigna.com/cfb/profile-settings/v1/change-password',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/client/clients/search',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/contenthub/content/alert',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/contenthub/content/alert/update',
      'https://a-cfb.test.digitaledge.cigna.com/secure/v1/ca/identity/utility/isIpValid',
      'https://a-cfb.test.digitaledge.cigna.com/secure/v1/ca/contenthub/content/',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/preferences/user/agreementstatus',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation/access/get_firms',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation/search/compensation-tile',
      'https://a-cfb.test.digitaledge.cigna.com/service/RequestsForProposals',
      'https://a-cfb.test.digitaledge.cigna.com/service/ContactCard',

      `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation/access/add_firm`,
      '/isam/sps/broker-int2-idp-healthsherpa/saml20/logininitial',
      '/equotes',
      '/web/commissions-overview',
      'https://int2.cignaforbrokers.com/isam/sps/broker-int2-idp-employer-int-03/saml20/logininitial',
      'https://int-cignaforemployers-03.cigna.com/isam/sps/employer-int-03-sp-broker-int2/saml20',
      '/web/resource-center',
      'https://int2.cignaforbrokers.com/isam/sps/broker-int2-idp-connecture-cigna/saml20/logininitial',
      'https://rlse.cignaforbrokers.com/equotes/',
      'https://dev-producer-dev.cs34.force.com/s/current-business',
      '/web/book-of-business',
      'https://rlse.cignaforbrokers.com/web/gov-bob',
      `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation/access/remove_firm`,
      `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation/affirmations/agencies`,
      `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation/affirmations/affirm`,
      '/usr-desktop-v2/#/sep-applications/search',
      '/web/admin',
      '/usr-desktop-v2/#/sep-applications/search',
      'https://dev-producer-dev.cs34.force.com/s/request-for-proposals',
      'https://dev-producer-dev.cs34.force.com/s/compensation-page',
      'https://dev-producer-dev.cs34.force.com/s/on-demand-training',
      'https://dev-producer-dev.cs34.force.com/s/solutions-and-insights',
      'https://rlse.cignaforbrokers.com/web/broker-security-profile',
      'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athlv/contents',
      'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athno/contents/tool/',
      'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athno/contents/spotlight/',
      'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athno/contents/business-instant-alert/',
      `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/rfi`,
      `https://rlse.cignaforbrokers.com/isam/sps/broker-int2-idp-salesforce-accenture/saml20/logininitial`,
      'https://rlse.cignaforbrokers.com/isam/sps/broker-int2-idp-connecture-cigna/saml20/logininitial',
      'https://rlse.cignaforbrokers.com/equotes/',
      'https://rlse.cignaforbrokers.com/web/gov-bob',
      'https://rlse.cignaforbrokers.com/gasbAgent/AgencyManagement/CommissionsandDebitBalance.aspx',
      'https://rlse.cignaforbrokers.com/gasbAgent/FormsAndMaterials/FormsAndMaterials_POD.aspx',
      'https://rlse.cignaforbrokers.com/web/incentives',
      'https://rlse.cignaforbrokers.com/gasbAgent/AgencyManagement/MyClients.aspx',
      'https://rlse.cignaforbrokers.com/gasbagent/agencymanagement/productionreports/reportselection.aspx',
      'https://rlse.cignaforbrokers.com/gasbagent/AgencyManagement/activeagentssearch.aspx',
      'https://rlse.cignaforbrokers.com/gasbAgent/ExpressWay.aspx',
      'https://cigna.uat4.pinpointglobal.com/Portal/Login',
      'https://rlse.cignaforbrokers.com/web/gov-resource-center/product-info',
      'https://rlse.cignaforbrokers.com/web/gov-resource-center/business-building',
      `https://rlse.cignaforbrokers.com/web/gov-resource-center/benefits`,
      'https://rlse.cignaforbrokers.com/gasbAgent/FormsAndMaterials/ServicingForms.aspx',
      'https://rlse.cignaforbrokers.com/equotes/',
      'https://rlse.cignaforbrokers.com/gasbAgent/ExpressWay.aspx',
      `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/compensation/access/add-admin-relationship`,
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/notification',
      'https://dev-producer-dev.cs34.force.com/s/continuing-education',
      'https://hcpdirectory.cigna.com/web/public/consumer/directory',
      'https://www.cigna.com/individuals-families/member-resources/prescription/',
      'https://staging.healthsherpa.com/',
      'https://staging.healthsherpa.com/',
      'https://www.cigna.com/',
      'https://cignaforemployers.cigna.com/public/app/signin',
      '/isam/sps/broker-int2-idp-healthsherpa/saml20/logininitial',
      'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athno/contents/content-block',
      'https://rlse.cignaforbrokers.com/isam/sps/broker-int2-idp-connecture-cigna/saml20/logininitial',
      'https://a-cfb.test.digitaledge.cigna.com/service/CurrentBusiness',
      'https://a-cfb.test.digitaledge.cigna.com/service/ClientProductsSummary',
      'https://a-cfb.test.digitaledge.cigna.com/service/ContactCard',
      `https://a-cfb.test.digitaledge.cigna.com/v1/cfb/ma/compensation`,
      'https://rlse.cignaforbrokers.com/isam/sps/broker-int2-idp-bigtincan/saml20/logininitial',
      'https://rlse.cignaforbrokers.com/isam/sps/broker-int2-idp-kaplan/saml20/logininitial',
      'https://a-cfb.test.digitaledge.cigna.com/v2/contents',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/wipro',
      'https://a-cfb.test.digitaledge.cigna.com/v1/medicaidEligLookup',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/util/token',
      'https://sit.test-cignaforemployers.cigna.com/public/app/signin',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/ma/compensation/report',
      'https://a-cfb.test.digitaledge.cigna.com/v1/secure/cfb/email/notification',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/profile/user/logindate',
      'https://d.login.cignaforbrokers.com/api/v1/authn/recovery/token',
      'https://cigna.service-now.com/esp',
    ],
    secureUris: [
      'secure/home/',
      'https://a-cfb.test.digitaledge.cigna.com',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb',
      'https://a-gsg.test.digitaledge.cigna.com',
      'https://a-gsg.test.digitaledge.cigna.com',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb',
      'https://a-cfb.test.digitaledge.cigna.com',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb',
      'https://v-gsg.test.digitaledge.cigna.com',
      'https://p-gsg.digitaledge.cigna.com',
      'https://p-cfb.digitaledge.cigna.com',
      'https://p-cfb.digitaledge.cigna.com/v1/cfb',
      'https://f-gsg.digitaledge.cigna.com',
      'https://f-cfb.digitaledge.cigna.com',
      'https://f-cfb.digitaledge.cigna.com/v1/cfb',
      'https://producer-dev.aws.cignacloud.com/service',
      'https://a-cfb.test.digitaledge.cigna.com',
      'https://d-cignaaccess.dev.digitaledge.cigna.com/v1/ca',
      'https://a-cignaaccess.test.digitaledge.cigna.com/v1/ca',
      'https://a-cignaaccess.test.digitaledge.cigna.com/v1/ca',
      'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athno/contents/message',
      'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athno/contents/tool/',
      'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athno/contents/spotlight/',
      'https://a-gsg.test.digitaledge.cigna.com/caas/api/v1/athno/contents/business-instant-alert/',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/profile/navigation',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfe/identity/profile/user/match',
      'https://rlse.cignaforbrokers.com/service/v1/retail/broker/roles/default',
      'https://rlse.cignaforbrokers.com/isam/sps/oidc/rp/brokers-rlse-okta/kickoff/okta-rlse-brokers?Target=/keepalive.gif',
    ],
    publicUris: [
      'https://a-cfb.test.digitaledge.cigna.com/public/recovery/v1/mfa/factor/sq/verify',
      'https://a-cfb.test.digitaledge.cigna.com/public/recovery/v1/password/reset',
      'https://a-cfb.test.digitaledge.cigna.com/public/recovery/v1/password/search',
      'https://a-cfb.test.digitaledge.cigna.com/public/recovery/v1/user/search',
      'https://a-cfb.test.digitaledge.cigna.com/public/recovery/v1/mfa/factor/verify',
      'https://a-cfb.test.digitaledge.cigna.com/public/recovery/v1/mfa/factor/send',
      'https://a-cfb.test.digitaledge.cigna.com/v1/cfb/identity/profile/login',
      'https://a-cfb.test.digitaledge.cigna.com/v1/public/cfb/email/notification',
    ],
    noRefreshUris: [],
  },
};
